import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../Actions/Dialogs/DialogActions";
import { type RootState } from "../../Reducers/ShopfrontReducers";

const connector = connect((state: RootState) => ({
    kicked: state.location.kicked,
}));

type PropsFromRedux = ConnectedProps<typeof connector> & {
    dispatch: ThunkDispatch<any, any, any>;
};

export class RegisterTakeover extends React.Component<PropsFromRedux> {
    public componentDidUpdate(prevProps: Readonly<PropsFromRedux>): void {
        if(prevProps.kicked !== false && this.props.kicked === false) {
            this.props.dispatch(hideDialog());
        }
    }

    public render(): React.ReactNode {
        if(!this.props.kicked) {
            return null;
        }

        return (
            <p>{this.props.kicked.user} has taken over this register.</p>
        );
    }
}

export default connector(RegisterTakeover);
